import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import ui framework
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'

// Import custom styles
import './assets/styles/app.styl'

// Import http(s) client
import axios from 'axios'

axios.defaults.baseURL = '/api'
import VueAxios from 'vue-axios'
import axiosSetup from './plugins/axios'

// Import authorization module
import VueAuth from '@websanova/vue-auth'
import AuthDriver from '@websanova/vue-auth/drivers/auth/bearer'
import HttpDriver from '@websanova/vue-auth/drivers/http/axios.1.x'
import RouterDriver from '@websanova/vue-auth/drivers/router/vue-router.2.x'

// Import drag and drop module
import VueDragDrop from 'vue-drag-drop'

// Import layouts
import LoginLayout from './layouts/Login'
import DefaultLayout from './layouts/Default'

// Register layouts as components
Vue.component('login-layout', LoginLayout)
Vue.component('default-layout', DefaultLayout)
Vue.prototype.$layout = 'default'

// Register ui framework
Vue.use(Vuesax)

// Register http(s) client
Vue.use(VueAxios, axios)
axiosSetup()

// Register authorization module
Vue.router = router
Vue.use(VueAuth, {
  auth: AuthDriver,
  http: HttpDriver,
  router: RouterDriver,
  tokenDefaultName: 'accessToken',
  tokenStore: ['cookie'],
  parseUserData: data => data,
  refreshData: {
    enabled: false
  }
})

// Register drag and drop module
Vue.use(VueDragDrop)

Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
